<div style="padding-right: 8px;">
  <ng-content></ng-content>
</div>
